import { Link } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import MarketingLayout from '@/layouts/MarketingLayout'

function HomeIndex() {
  return (
    <div className="mx-auto max-w-2xl py-24 text-center">
      <h1 className="text-5xl font-semibold mb-3">FindMedStaff</h1>
      <div className="mx-auto mb-8 h-1 w-6 rounded-full bg-amber"></div>
      <Button asChild size="lg">
        <Link href="/login">Sign Up</Link>
      </Button>
    </div>
  )
}

HomeIndex.layout = (page: React.ReactNode) => <MarketingLayout>{page}</MarketingLayout>

export default HomeIndex
